
define('eteration/widgets/ui-dropdownselect',[
        'knockout',
        'eteration/widgets/widget-util',
        'eteration/eteration-i18n',
        'eteration/eteration'
    ],
    function (ko, widgetUtil, i18n, etr) {

        widgetUtil.setupStringBasedTemplate(ko);

        ko.bindingHandlers.dropdownregioncodes = {

            update: function (element, valueAccessor, allBindingsAccessor) {

                var $element = $(element);
                var optionsData = ko.utils.unwrapObservable(valueAccessor()).optionsData() || {};

                if (optionsData.length > 0 && $element[0].childElementCount == 0) {

                    var optionCaptionLanguageKeyword = valueAccessor().optionCaptionLanguageKeyword || 'Label-OB-103';
                    var optionLabelPrefix = valueAccessor().optionLabelPrefix || null;

                    var visibleText = i18n.get(optionCaptionLanguageKeyword);
                    var ariaText = optionLabelPrefix ? i18n.get(optionLabelPrefix) : visibleText;

                    var firstOptionHtml = '<option value="" data-content="&nbsp;' + visibleText + '" aria-label="' + ariaText + '"></option>';
                    var optionsHtml = firstOptionHtml;

                    var valueField = valueAccessor().valueField || 'code';
                    var displayField = valueAccessor().displayField || 'name';

                    var identifiedCountry = i18n.getUserCountry().toUpperCase();
                    var defaultSelectedValue = valueAccessor().defaultSelection;
                    var fillInitialValue = ko.utils.unwrapObservable(valueAccessor().fillInitialValue);
                    
                    var fillRegionShortName = ko.utils.unwrapObservable(valueAccessor().fillRegionShortName);

                    if (fillInitialValue == undefined)
                        fillInitialValue = true;
                    
                    if (fillRegionShortName == undefined)
                    	fillRegionShortName = false;


                    for (var i = 0; i < optionsData.length; i++) {
                        var countryName = i18n.get('countrylookup.' + optionsData[i][displayField]).replace('\'', '&#39;');
                        var optionHtml;
                        if(fillRegionShortName){
                        	optionHtml = '<option value="' + optionsData[i][valueField] + '-' + optionsData[i][displayField] + '" data-content=\'';
                        } else{
                        	optionHtml = '<option value="' + optionsData[i][valueField] + '" data-content=\'';
                        }
                        
                        var content = '<span class="hidden-select-text">' + countryName + '</span>' + ' <span class="hidden-select-text">(</span><span class="rtl-reverse-text d-inline-block">+' + optionsData[i][valueField] + '</span><span class="hidden-select-text">)</span>';
                        var optionDataContentHtml = '<div class="flags icon-' + optionsData[i][displayField].toUpperCase() + '" alt="' + countryName + '"></div>&nbsp;' + content;
                        optionHtml += optionDataContentHtml + '\'>' + content + '</option>';
                        optionsHtml += optionHtml;

                        if (defaultSelectedValue == '' && fillInitialValue) {
                            if (optionsData[i][displayField].toUpperCase() == identifiedCountry) {
                                defaultSelectedValue = optionsData[i][valueField];
                            }
                        }
                    }
                    $element.append(optionsHtml);

    				if(defaultSelectedValue){
                        allBindingsAccessor().value(defaultSelectedValue);
    				}
                }
                $element.selectpicker('refresh');
    			$element.parent().find('button.dropdown-toggle.selectpicker').attr('title', '');
               	$element.on('change', function () {
					$(this).parent().find('button.dropdown-toggle.selectpicker').attr('title', '');});
            }
        };

        ko.bindingHandlers.dropdowncountryregioncodes = {

                update: function (element, valueAccessor, allBindingsAccessor) {

                    var $element = $(element);
                    var optionsData = ko.utils.unwrapObservable(valueAccessor()).optionsData() || {};

                    if (optionsData.length > 0 && $element[0].childElementCount == 0) {

                        var optionCaptionLanguageKeyword = valueAccessor().optionCaptionLanguageKeyword || 'Label-OB-103';

                        var firstOptionHtml = '<option value="" data-content=\'' + '&nbsp;' + i18n.get(optionCaptionLanguageKeyword) + '' + '\'>' + '</option>';
                        var optionsHtml = firstOptionHtml;

                        var valueFunction = valueAccessor().valueFunction || 'id';
                        var countryNameField = valueAccessor().displayField || 'name';
                        var regionField = valueAccessor().regionField || 'region';
                        var countryCodeField = valueAccessor().countryCodeField || 'code';

                        var identifiedCountry = i18n.getUserCountry().toUpperCase();
                        var defaultSelectedValue = valueAccessor().defaultSelection || '';
                        var fillInitialValue = ko.utils.unwrapObservable(valueAccessor().fillInitialValue);

                        if (fillInitialValue == undefined)
                            fillInitialValue = true;

                        for (var i = 0; i < optionsData.length; i++) {
                        	
                        	var countryName = optionsData[i][countryNameField].replace('\'', '&#39;');
                        	var optionHtml = '<option value="' + optionsData[i][valueFunction]() + '" data-content=\'';

                            var content = '<span class="hidden-select-text">' + countryName + '</span>' + ' <span class="hidden-select-text">(</span><span class="rtl-reverse-text d-inline-block">+' + optionsData[i][regionField] + '</span><span class="hidden-select-text">)</span>';
                            var optionDataContentHtml = '<div class="flags icon-' + optionsData[i][countryCodeField].toUpperCase() + '" alt="' + countryName + '"></div>&nbsp;' + content;
                            optionHtml += optionDataContentHtml + '\'>' +  '</option>';
                            optionsHtml += optionHtml;

                           if (defaultSelectedValue == '' && fillInitialValue) {
                            	
                                if (optionsData[i][countryCodeField].toUpperCase() == identifiedCountry) {
                               		defaultSelectedValue = optionsData[i][valueFunction]();
                                }
                            }
                        }
                        $element.append(optionsHtml);

        				if(defaultSelectedValue){
                            allBindingsAccessor().value(defaultSelectedValue);
        				}
                    }
                    $element.selectpicker('refresh');
                    setTimeout(function(){
                    	$element.parent().find('button.dropdown-toggle.selectpicker').attr('title', '');
                       	$element.on('change', function () {
        					$(this).parent().find('button.dropdown-toggle.selectpicker').attr('title', '');
        				});
                    },2500);
        			
                   	
                }
            };
      
        ko.bindingHandlers.phoneTypeDropdownSelect = {

            update: function (element, valueAccessor, allBindingsAccessor) {

                var $element = $(element);
                var optionsData = ko.utils.unwrapObservable(valueAccessor()).optionsData() || {};

                if (optionsData.length > 0) {

                    optionsData.sort();

                    var firstOptionHtml = '<option value="' + optionsData[0].code + '" data-content=\'';
                    var content = optionsData[0].name + "";
                    var firstOptionDataContentHtml = '<span></span>' + content;
                    firstOptionHtml += firstOptionDataContentHtml + '</option>';
                    var optionsHtml = firstOptionHtml;

                    for (var i = 1; i < optionsData.length; i++) {

                        var optionHtml = '<option value="' + optionsData[i].code + '" data-content=\'';
                        content = optionsData[i].name + "";
                        var optionDataContentHtml = '<span></span>' + content;
                        optionHtml += optionDataContentHtml + '</option>';
                        optionsHtml += optionHtml;
                    }

                    $element.append(optionsHtml);
                    $element.selectpicker('refresh');
                }
            }
        };

    });
